import { useEffect, useState } from 'react';

import { trpc, TrpcOutputs } from '../../config/trpc';

export type UseQuoteCounts = [TrpcOutputs['getQuoteCountsByRequestId'] | undefined, boolean, string | undefined];

export const useQuoteCounts = (requestId: number): UseQuoteCounts => {
  const {
    data: initialData,
    isLoading,
    error: initialError,
  } = trpc.getQuoteCountsByRequestId.useQuery({ requestId }, { enabled: !!requestId });
  const [error, setError] = useState<string>(initialError?.message);
  const [data, setData] = useState<TrpcOutputs['getQuoteCountsByRequestId'] | undefined>(
    initialData || ({} as TrpcOutputs['getQuoteCountsByRequestId']),
  );

  useEffect(() => {
    if (initialData) setData(initialData);
  }, [initialData]);

  useEffect(() => {
    if (initialError?.message) setError(initialError.message);
  }, [initialError?.message]);

  trpc.onQuoteUpdated.useSubscription({ requestId } as any, {
    onData: (updatedQuote) => {
      setData((prevData) => {
        const prevStatus = Object.keys(prevData).find((key) => prevData?.[key]?.includes(updatedQuote.id));

        const nextStatus = updatedQuote.status;
        if (prevStatus === nextStatus) return prevData;

        return {
          ...prevData,
          [prevStatus]: prevData?.[prevStatus]?.filter((id: number) => id !== updatedQuote.id) || [],
          [nextStatus]: [...(prevData?.[nextStatus] || []), updatedQuote.id],
        };
      });
    },
    onError: (err: any) => {
      console.log('onQuoteUpdated error: ', err);
      setError(err?.message);
    },
  });

  trpc.onQuoteDeleted.useSubscription({ requestId } as any, {
    onData: (deletedQuoteId) => {
      setData((prevData) => {
        const status = Object.keys(prevData).find((key) => prevData?.[key]?.includes(deletedQuoteId));
        if (!status) return prevData;

        return {
          ...prevData,
          [status]: prevData?.[status]?.filter((id: number) => id !== deletedQuoteId) || [],
        };
      });
    },
    onError: (err: any) => {
      console.log('onQuoteDeleted error: ', err);
      setError(err?.message);
    },
  });

  return [data, Boolean(isLoading), error];
};
